export default "__VITE_ASSET__0lyE0UYc__"